import React, { useState } from 'react'
import PropTypes from 'prop-types'
import posed from 'react-pose'
import Button from './utils/Button'
import { ReactComponent as CloseIcon } from '../assets/icons/icon-close.svg'
import { UNAVAILABLE_BAY_ID } from '../core/constants'

const propTypes = {
  bays: PropTypes.array,
  orderId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onBayConfirmation: PropTypes.func,
}

const BayButton = posed.button({
  selected: {
    borderRadius: '100%',
    backgroundColor: '#00A82D',
    color: '#ffffff',
  },
  unselected: {
    borderRadius: '10%',
    backgroundColor: '#ffffff',
    color: '#383b3a',
  },
})

const BaySelector = props => {
  const { bays, orderId, onClose, onBayConfirmation, callingAPI } = props
  const [selectedBay, setSelectedBay] = useState()
  const [showForm, setShowForm] = useState(false)
  const [carReg, setCarReg] = useState('')

  function handleBaySelection(bayId) {
    setSelectedBay(bayId)
    if (bayId === UNAVAILABLE_BAY_ID) {
      setShowForm(true)
    }
  }

  function handleFormSubmission(event) {
    onBayConfirmation(carReg)
    event.preventDefault()
  }

  function renderBays() {
    return (
      <div className="flex flex-wrap items-start content-start w-full mb-4">
        <p className="w-full mb-2 text-xl font-semibold leading-tight">
          Where are you parked?
        </p>
        <span className="block mb-4">
          If you are parked in a Click & Collect space please tell us which one:
        </span>
        <div className="flex flex-wrap flex-auto min-w-full -mx-8 overflow-x-auto scrolling-touch lg:-mx-6">
          {bays.map(bay => (
            <div
              className="bay-flex"
              key={bay.id}
              data-bay-id={bay.id}
              data-bay-selection-status={
                selectedBay === bay.id ? 'selected' : 'unselected'
              }
            >
              <BayButton
                pose={selectedBay === bay.id ? 'selected' : 'unselected'}
                className="mx-2 mb-6 text-3xl font-semibold shadow-sm cursor-pointer focus:outline-none"
                onClick={handleBaySelection.bind(this, bay.id)}
              >
                <span
                  aria-label={
                    bay.id === UNAVAILABLE_BAY_ID
                      ? 'I am parked Nearby'
                      : `parking bay ${bay.name}`
                  }
                  className="flex items-center justify-center h-16 px-4 leading-none text-center whitespace-no-wrap select-none min-w-16"
                >
                  {bay.name}
                </span>
              </BayButton>
            </div>
          ))}
        </div>
        <Button
          variant="tertiary"
          disabled={selectedBay ? false : true}
          onClick={onBayConfirmation.bind(this, selectedBay)}
        >
          <span className="block w-full text-center">
            {callingAPI ? 'Loading...' : 'Confirm'}
          </span>
        </Button>
      </div>
    )
  }

  function renderForm() {
    function isValidReg() {
      return carReg && /^[A-Za-z0-9]+$/.test(carReg) && carReg.length === 3
    }

    return (
      <div
        className="flex flex-wrap items-start content-start w-full mb-4"
        data-cy="bay-selector-form"
      >
        <p
          className="w-full mb-4 text-xl font-medium"
          id="bay-selector--car-reg-label"
        >
          To help us find you, please tell us the{' '}
          <span className="font-semibold">
            last three characters of your car registration.
          </span>
        </p>
        <form className="w-full" action="" onSubmit={handleFormSubmission}>
          <input
            className={`w-full rounded bg-primary-lightest border-2 border-primary-lightest 
              focus:border-primary-lightest focus:bg-white text-base p-3 mb-8 outline-none uppercase`}
            type="text"
            aria-labelledby="bay-selector--car-reg-label"
            value={carReg}
            onChange={event => setCarReg(event.target.value)}
            maxLength="3"
            placeholder="Last 3 characters of your car registration"
          />
          <Button variant="tertiary" disabled={isValidReg() ? false : true}>
            <span className="block w-full text-center">
              {callingAPI ? 'Loading...' : 'Confirm'}
            </span>
          </Button>
        </form>
      </div>
    )
  }

  if (!orderId) return null
  return (
    <div
      className="flex flex-wrap w-full px-6 py-8 bg-white rounded-t-modal lg:max-w-lg"
      data-cy="bay-selector"
    >
      <div className="flex items-start content-start w-full mb-4">
        <div className="flex-1">
          <p className="mb-1 text-xl font-semibold leading-none">
            Order number
          </p>
          <p className="mb-1 text-3xl font-semibold leading-none break-all text-secondary">
            {orderId}
          </p>
        </div>
        <div className="px-4 py-2 cursor-pointer" onClick={onClose}>
          <CloseIcon className="absolute top-0 right-0 block w-10 h-10 mt-4 mr-4" />
        </div>
      </div>
      {showForm ? renderForm() : renderBays()}
    </div>
  )
}

BaySelector.propTypes = propTypes

export default BaySelector
